export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export function formatTime(timestamp) {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export function renderMarkdown(text) {
  if (!text) return null;
  const parts = text.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, i) => {
    if (part.startsWith("**") && part.endsWith("**")) {
      return (
        <strong key={i} className="font-semibold">
          {part.slice(2, -2)}
        </strong>
      );
    }
    return <span key={i}>{part}</span>;
  });
}

/** Push a server-returned message straight into the open chat. */
export function emitMessage(msg) {
  if (msg) window.dispatchEvent(new CustomEvent("elderra:message", { detail: msg }));
}

/** The left-bordered card every rich bot message uses. */
export const CardShell = ({ message, testId, borderClass, className = "", children }) => (
  <div className="flex justify-start message-enter" data-testid={`msg-${message.id}`}>
    <div
      className={`bubble-received shadow-sm p-4 max-w-[90%] border-l-4 ${borderClass} ${className}`}
      data-testid={testId}
    >
      {children}
      <span className="text-xs text-gray-400 mt-2 block">{formatTime(message.timestamp)}</span>
    </div>
  </div>
);
